import React from "react";
import { MapPin, Phone, Instagram, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";

const WHATSAPP_URL = "https://wa.me/56975359774?text=" + encodeURIComponent("Hola, quiero personalizar una funda");
const MAPS_URL = "https://www.google.com/maps/search/?api=1&query=" + encodeURIComponent("Ossa Cerda 275, Galería Americano local 8, Caldera, Chile");
const INSTAGRAM_URL = "https://www.instagram.com/torviaccesorios.cl?igsh=ZzF2NGxuN2Y3cW1n";

export default function Footer() {
  return (
    <footer className="bg-black text-white pt-16 pb-10" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3">
            <img src="/brand/torvi_icon.png" alt="Torvi" className="h-12 w-auto" />
            <div>
              <div className="font-heading font-black text-xl">TORVI</div>
              <div className="text-[10px] uppercase tracking-[0.25em] text-slate-400 font-bold">Accesorios</div>
            </div>
          </div>
          <p className="text-slate-400 mt-4 max-w-sm leading-relaxed">
            Personaliza tu funda en 15 minutos. Carcasas únicas con tus fotos, nombres o diseños. Envíos a todo Chile.
          </p>
          <div className="flex gap-2 mt-5">
            <a href={WHATSAPP_URL} target="_blank" rel="noreferrer" data-testid="footer-whatsapp" className="w-10 h-10 rounded-full bg-emerald-500 hover:bg-emerald-600 flex items-center justify-center transition" aria-label="WhatsApp">
              <i className="fa-brands fa-whatsapp text-lg" />
            </a>
            <a href={INSTAGRAM_URL} target="_blank" rel="noreferrer" data-testid="footer-instagram" className="w-10 h-10 rounded-full bg-gradient-to-br from-pink-500 via-fuchsia-500 to-amber-500 hover:opacity-90 flex items-center justify-center transition" aria-label="Instagram">
              <Instagram size={17} />
            </a>
            <a href={MAPS_URL} target="_blank" rel="noreferrer" data-testid="footer-maps" className="w-10 h-10 rounded-full bg-sky-500 hover:bg-sky-600 flex items-center justify-center transition" aria-label="Google Maps">
              <MapPin size={17} />
            </a>
          </div>
        </div>

        <div>
          <div className="text-xs uppercase tracking-widest font-bold text-slate-400 mb-4">Tienda</div>
          <ul className="space-y-2 text-slate-300 text-sm">
            <li><Link to="/" className="hover:text-[#0EA5E9]">Inicio</Link></li>
            <li><Link to="/personalizar" className="hover:text-[#0EA5E9]">Personalizar funda</Link></li>
            <li><Link to="/accesorios" className="hover:text-[#0EA5E9]">Accesorios</Link></li>
            <li><Link to="/emprende" className="hover:text-[#0EA5E9]">Emprende</Link></li>
            <li><Link to="/contacto" className="hover:text-[#0EA5E9]">Contacto</Link></li>
            <li><Link to="/admin/login" className="hover:text-[#0EA5E9]">Admin</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-xs uppercase tracking-widest font-bold text-slate-400 mb-4">Contacto</div>
          <ul className="space-y-3 text-slate-300 text-sm">
            <li>
              <a href={MAPS_URL} target="_blank" rel="noreferrer" className="flex gap-2 hover:text-[#0EA5E9]">
                <MapPin size={16} className="text-[#0EA5E9] mt-0.5 flex-shrink-0" />
                <span>Ossa Cerda 275, Galería Americano local 8, Caldera</span>
              </a>
            </li>
            <li>
              <a href={WHATSAPP_URL} target="_blank" rel="noreferrer" className="flex gap-2 hover:text-emerald-400">
                <Phone size={16} className="text-[#0EA5E9] mt-0.5 flex-shrink-0" />
                <span>+56 9 7535 9774</span>
              </a>
            </li>
            <li>
              <a href={INSTAGRAM_URL} target="_blank" rel="noreferrer" className="flex gap-2 hover:text-pink-400">
                <Instagram size={16} className="text-[#0EA5E9] mt-0.5 flex-shrink-0" />
                <span>@torviaccesorios.cl</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12 border-t border-white/10 mt-10 pt-6 flex flex-col md:flex-row justify-between gap-3 text-xs text-slate-500">
        <div>© {new Date().getFullYear()} Torvi Accesorios. Todos los derechos reservados.</div>
        <div>Hecho con ❤️ en Caldera, Chile</div>
      </div>
    </footer>
  );
}
